/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ expiresAtString: NonNullable<unknown> }} Sea_Tiny_Anaconda_InspireInputs */

const en_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your subscription has been canceled. Access until ${i?.expiresAtString}.`)
};

const id_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Langganan Anda telah dibatalkan. Akses hingga ${i?.expiresAtString}.`)
};

const ms_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Langganan anda telah dibatalkan. Akses sehingga ${i?.expiresAtString}.`)
};

const ca_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`S'ha cancel·lat la teva subscripció. Accés fins al ${i?.expiresAtString}.`)
};

const cs_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vaše předplatné bylo zrušeno. Přístup budete mít do ${i?.expiresAtString}.`)
};

const da_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dit abonnement er blevet opsagt. Du har adgang indtil ${i?.expiresAtString}.`)
};

const de_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Abonnement wurde gekündigt. Du hast noch Zugriff bis zum ${i?.expiresAtString}.`)
};

const et_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teie tellimus on tühistatud. Juurdepääs aegub ${i?.expiresAtString}.`)
};

const es_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu suscripción ha sido cancelada. Tienes acceso hasta el ${i?.expiresAtString}.`)
};

const fr_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre abonnement a bien été annulé. Votre accès prendra fin le ${i?.expiresAtString}.`)
};

const hr_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vaša je pretplata otkazana. Imate pristup do ${i?.expiresAtString}.`)
};

const it_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo abbonamento è stato cancellato. Hai accesso fino al: ${i?.expiresAtString}.`)
};

const lv_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jūsu abonements ir atcelts. Piekļuve aktīva līdz ${i?.expiresAtString}.`)
};

const lt_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jūsų prenumerata buvo atšaukta. Prieiga aktyvi iki ${i?.expiresAtString}.`)
};

const hu_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Az előfizetését törölték. Hozzáférés a ${i?.expiresAtString}.`)
};

const nl_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je abonnement is opgezegd. Je hebt toegang tot ${i?.expiresAtString}.`)
};

const nb_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnementet ditt er sagt opp. Du har tilgang frem til ${i?.expiresAtString}.`)
};

const pl_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Twoja subskrypcja została anulowana. Masz dostęp do ${i?.expiresAtString}.`)
};

const pt_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sua assinatura foi cancelada. Seu acesso expira em ${i?.expiresAtString}.`)
};

const ro_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonamentul tău a fost anulat. Ai acces până la ${i?.expiresAtString}.`)
};

const sk_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vaše predplatné bolo zrušené. Prístup máte do ${i?.expiresAtString}.`)
};

const sl_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vaša naročnina je bila preklicana. Dostop do ${i?.expiresAtString}.`)
};

const fi_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilauksesi on peruttu. Käyttöoikeutesi umpeutuu ${i?.expiresAtString}.`)
};

const sv_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Din prenumeration har avbrutits. Du har åtkomst fram till ${i?.expiresAtString}.`)
};

const vi_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gói đăng ký của bạn đã được hủy. Có thể sử dụng đến hết ${i?.expiresAtString}.`)
};

const tr_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aboneliğiniz iptal edildi. ${i?.expiresAtString} tarihine kadar erişebilirsiniz.`)
};

const el_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Η συνδρομή σας ακυρώθηκε. Θα έχετε πρόσβαση μέχρι τις ${i?.expiresAtString}.`)
};

const bg_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Абонаментът ти е прекратен. Достъпът е активен до ${i?.expiresAtString}.`)
};

const ru_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваша подписка была отменена. Доступ до ${i?.expiresAtString}.`)
};

const sr_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваша претплата је отказана. Имате приступ до ${i?.expiresAtString}.`)
};

const uk_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вашу підписку скасовано. Доступ до ${i?.expiresAtString}.`)
};

const ka_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`თქვენი გამოწერა გაუქმებულია. წვდომა გექნებათ ${i?.expiresAtString}-მდე.`)
};

const hi_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आपका सब्सक्रिप्शन रद्द कर दिया गया है। ${i?.expiresAtString} तक एक्सेस करें।`)
};

const th_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`การเป็นสมาชิกของคุณถูกยกเลิกแล้ว แต่เข้าถึงได้จนถึงวันที่ ${i?.expiresAtString}`)
};

const ko_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`구독이 취소되었습니다. ${i?.expiresAtString}까지 이용하실 수 있습니다.`)
};

const zh_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您的订阅已取消。在 ${i?.expiresAtString}之前您仍可对其进行访问。 `)
};

const zh_tw_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您的訂閱已被取消。可使用至 ${i?.expiresAtString} 止。`)
};

const ja_sea_tiny_anaconda_inspire = /** @type {(inputs: Sea_Tiny_Anaconda_InspireInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`あなたのサブスクリプションはキャンセルされました。 ${i?.expiresAtString} までアクセスできます。`)
};

/**
* | output |
* | --- |
* | "Your subscription has been canceled. Access until {expiresAtString}." |
*
* @param {Sea_Tiny_Anaconda_InspireInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const sea_tiny_anaconda_inspire = /** @type {((inputs: Sea_Tiny_Anaconda_InspireInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sea_Tiny_Anaconda_InspireInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sea_tiny_anaconda_inspire(inputs)
	if (locale === "ms") return ms_sea_tiny_anaconda_inspire(inputs)
	if (locale === "ca") return ca_sea_tiny_anaconda_inspire(inputs)
	if (locale === "cs") return cs_sea_tiny_anaconda_inspire(inputs)
	if (locale === "da") return da_sea_tiny_anaconda_inspire(inputs)
	if (locale === "de") return de_sea_tiny_anaconda_inspire(inputs)
	if (locale === "et") return et_sea_tiny_anaconda_inspire(inputs)
	if (locale === "es") return es_sea_tiny_anaconda_inspire(inputs)
	if (locale === "fr") return fr_sea_tiny_anaconda_inspire(inputs)
	if (locale === "hr") return hr_sea_tiny_anaconda_inspire(inputs)
	if (locale === "it") return it_sea_tiny_anaconda_inspire(inputs)
	if (locale === "lv") return lv_sea_tiny_anaconda_inspire(inputs)
	if (locale === "lt") return lt_sea_tiny_anaconda_inspire(inputs)
	if (locale === "hu") return hu_sea_tiny_anaconda_inspire(inputs)
	if (locale === "nl") return nl_sea_tiny_anaconda_inspire(inputs)
	if (locale === "nb") return nb_sea_tiny_anaconda_inspire(inputs)
	if (locale === "pl") return pl_sea_tiny_anaconda_inspire(inputs)
	if (locale === "pt") return pt_sea_tiny_anaconda_inspire(inputs)
	if (locale === "ro") return ro_sea_tiny_anaconda_inspire(inputs)
	if (locale === "sk") return sk_sea_tiny_anaconda_inspire(inputs)
	if (locale === "sl") return sl_sea_tiny_anaconda_inspire(inputs)
	if (locale === "fi") return fi_sea_tiny_anaconda_inspire(inputs)
	if (locale === "sv") return sv_sea_tiny_anaconda_inspire(inputs)
	if (locale === "vi") return vi_sea_tiny_anaconda_inspire(inputs)
	if (locale === "tr") return tr_sea_tiny_anaconda_inspire(inputs)
	if (locale === "el") return el_sea_tiny_anaconda_inspire(inputs)
	if (locale === "bg") return bg_sea_tiny_anaconda_inspire(inputs)
	if (locale === "ru") return ru_sea_tiny_anaconda_inspire(inputs)
	if (locale === "sr") return sr_sea_tiny_anaconda_inspire(inputs)
	if (locale === "uk") return uk_sea_tiny_anaconda_inspire(inputs)
	if (locale === "ka") return ka_sea_tiny_anaconda_inspire(inputs)
	if (locale === "hi") return hi_sea_tiny_anaconda_inspire(inputs)
	if (locale === "th") return th_sea_tiny_anaconda_inspire(inputs)
	if (locale === "ko") return ko_sea_tiny_anaconda_inspire(inputs)
	if (locale === "zh") return zh_sea_tiny_anaconda_inspire(inputs)
	if (locale === "zh-tw") return zh_tw_sea_tiny_anaconda_inspire(inputs)
	if (locale === "ja") return ja_sea_tiny_anaconda_inspire(inputs)
	return en_sea_tiny_anaconda_inspire(inputs)
});